/** Resolve how a cutscene dialogue line advances, per the accessibility settings. Pure, no Babylon. */

export interface DialogueAdvanceSettings {
  dialogueAdvance: "auto" | "manual";
  dialogueDwellMultiplier: number;
}

export const DEFAULT_DIALOGUE_DURATION_MS = 3000;

export function resolveDialogueAdvance(
  settings: DialogueAdvanceSettings,
  stepDuration: number | undefined
): { mode: "auto" | "manual"; delayMs: number } {
  if (settings.dialogueAdvance === "manual") {
    return { mode: "manual", delayMs: 0 };
  }

  const base = stepDuration ?? DEFAULT_DIALOGUE_DURATION_MS;
  return { mode: "auto", delayMs: base * settings.dialogueDwellMultiplier };
}
